import { render, staticRenderFns } from "./CloseTitle.vue?vue&type=template&id=d8fd7744&scoped=true&"
import script from "./CloseTitle.vue?vue&type=script&lang=js&"
export * from "./CloseTitle.vue?vue&type=script&lang=js&"
import style0 from "./CloseTitle.vue?vue&type=style&index=0&id=d8fd7744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fd7744",
  null
  
)

export default component.exports